const objectUrlRevokeDelay = 30000

export const downloadUri = (uri: string, filename: string) => {
  const link = document.createElement("a")

  link.download = filename
  link.href = uri
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadByBlob = async (url: string, filename: string) => {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error("资源下载失败")
  }

  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)

  downloadUri(objectUrl, filename)
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), objectUrlRevokeDelay)
}
